import React from 'react';
import Layout from '../../components/Layout';
import ContentPagePreview from './ContentPagePreview';

async function action({ params }) {
    return {
        title: 'Content Page',
        component: (
            <Layout>
                <ContentPagePreview pageUrl={params.pageUrl} />
            </Layout>
        )
    };
}

export default action;
